/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Note_ErrorInputs */

const en_toast_note_error = /** @type {(inputs: Toast_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error adding audio note`)
};

const es_toast_note_error = /** @type {(inputs: Toast_Note_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al agregar nota de audio`)
};

/**
* | output |
* | --- |
* | "Error adding audio note" |
*
* @param {Toast_Note_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_note_error = /** @type {((inputs?: Toast_Note_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Note_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_note_error(inputs)
	return en_toast_note_error(inputs)
});